export default __webpack_public_path__ + "static/media/02-BB-(6-3).fbb2d88f.jpg";